import { effect, inject, signal, Signal } from '@angular/core';
import { Title } from '@angular/platform-browser';

export const useTitle = (
    titleSegments: Signal<string | string[] | null | undefined> = signal(
        undefined
    )
) => {
    const title = inject(Title);

    effect(() => {
        const segments = titleSegments() ?? [];
        const segmentsArray = Array.isArray(segments) ? segments : [segments];

        if (!segments?.length) {
            title.setTitle('siteboard - Scan it. Nail it. Scale it.');
        } else {
            title.setTitle([...segmentsArray, 'siteboard'].join(' • '));
        }
    });

    const titleFn = () => title.getTitle();
    titleFn.set = (value: string) => title.setTitle(value);

    return titleFn;
};
